import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { CompanyProfileData } from "../../../components/Models/CompanyProfileData";

type UpdateCompanyProfileDto = Partial<CompanyProfileData>;

export const useSaveCompanyProfile = (
  options?: UseMutationOptions<
    CompanyProfileData,
    unknown,
    CompanyProfileData | UpdateCompanyProfileDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<CompanyProfileData> | FormData) => {
      const isFormData = data instanceof FormData;

      // Determine if it's an update or create operation
      const hasId = isFormData
        ? data.get("id") ?? null
        : (data as Partial<CompanyProfileData>).id ?? null;

      // Set headers for FormData
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/MuslimInvestProfile/Company/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/MuslimInvestProfile/Company/Create"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
